/**
 * Плагин: по событию графа connection:relationship:updated шлёт patch updateRelationship.
 */
export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onRelationshipUpdated = ({connectionViewId, relationshipType, accessType} = {}) => {
			if (!connectionViewId) return;
			onPatch({
				patches: [
					{
						op: 'updateRelationship',
						viewIndex: VIEW_INDEX,
						identifier: connectionViewId,
						relationshipType,
						accessType,
					},
				],
			});
		};

		graph.on('connection:relationship:updated', onRelationshipUpdated);

		return () => graph.off('connection:relationship:updated', onRelationshipUpdated);
	},
};
